const splitRoleNames = (value) => {
  if (Array.isArray(value)) {
    return value.flatMap((item) => splitRoleNames(item));
  }

  if (value && typeof value === "object") {
    return splitRoleNames(value.name);
  }

  if (typeof value !== "string") return [];

  return value
    .split(",")
    .map((roleName) => roleName.trim())
    .filter(Boolean);
};

export const getUserRoleNames = (user) => {
  if (!user) return [];

  const roleNames = [
    ...splitRoleNames(user.roles),
    ...splitRoleNames(user.role_names),
    ...splitRoleNames(user.role_name),
    ...splitRoleNames(user.role),
  ];

  if (user.is_superadmin === true || Number(user.is_superadmin) === 1) {
    roleNames.push("SysAdmin");
  }

  const seenRoleNames = new Set();
  return roleNames.filter((roleName) => {
    const normalizedRoleName = roleName.toLocaleLowerCase("fr");
    if (seenRoleNames.has(normalizedRoleName)) return false;

    seenRoleNames.add(normalizedRoleName);
    return true;
  });
};

export const formatUserProfileLabel = (user, fallbackName = "Utilisateur") => {
  const userName = String(user?.name || fallbackName).trim() || fallbackName;
  const roleNames = getUserRoleNames(user);

  return roleNames.length > 0
    ? `${userName} [${roleNames.join(", ")}]`
    : userName;
};

